import { Outlet } from 'react-router-dom';
import Sidebar from '../Sidebar';
import Chatbot from '../Chatbot';
import './index.scss';


const Layout = () => {
    return (
        <div className="App">
            <Sidebar />
            <Chatbot />
            <div className="page">
                <span className='tags top-tags'>Swift</span>

                <Outlet />

                <span className='tags bottom-tags'>

                    < br />
                    <span className='bottom-tag-html'>& SwiftUI</span>
                </span>
            </div>
        </div>
    )
}

export default Layout 